// Dark right-aligned chat bubble for messages authored by the user.
// Ported verbatim from designproject/files/screens-feed.jsx (UserBubble).

import type { JSX } from 'preact';
import { T } from '../../tokens';

export interface UserBubbleProps {
  readonly text: string;
  readonly time?: string;
}

export function UserBubble({ text, time }: UserBubbleProps): JSX.Element {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 16px' }}>
      <div
        style={{
          maxWidth: '78%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 4,
        }}
      >
        <div
          style={{
            background: T.ink,
            color: '#fff',
            padding: '10px 14px',
            borderRadius: '18px 18px 4px 18px',
            fontSize: 14.5,
            lineHeight: 1.4,
            fontWeight: 500,
          }}
        >
          {text}
        </div>
        {time !== undefined && (
          <div style={{ fontSize: 11, color: T.ink3, fontWeight: 500 }}>{time}</div>
        )}
      </div>
    </div>
  );
}
